import { Classification, ClassificationGroups } from "@/api/studio/data/types/classification.type";
import { groupedClassifications } from "@/utils/classification-mapping";
import { sceneColors } from "@/utils/scene-color-mapping";

/* Prop Types */
interface ClassificationListProps {
  handleClassificationSelect: (value: string) => void;
  studyType: "asset" | "scene";
}

/*
 * ClassificationList component
 * This component is used to display a list of classifications for the user to select from
 * For asset studies, it shows classification types (logo, icon, etc.)
 * For scene studies, it shows a color palette
 */
export const ClassificationList = ({ handleClassificationSelect, studyType }: ClassificationListProps) => {
  /* Render */
  if (studyType === "scene") {
    return (
      <div className="flex flex-col gap-6">
        <h2 className="text-sm font-semibold">Choose AOI colour:</h2>
        {/* Color Grid */}
        <div className="grid grid-cols-5 gap-3">
          {sceneColors.map((color) => (
            <button
              key={color.hex}
              onClick={() => handleClassificationSelect(color.hex)}
              className="size-5 rounded transition-all hover:scale-105 active:scale-95 cursor-pointer"
              style={{ backgroundColor: color.hex }}
              title={color.name}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      {(Object.keys(groupedClassifications) as ClassificationGroups[]).map((classificationGroup) => (
        <div key={classificationGroup}>
          <p className="font-semibold bg-base-200 py-3 px-2 rounded-lg mb-2">{classificationGroup}</p>
          <div className="grid gap-2 items-center">
            {(Object.keys(groupedClassifications[classificationGroup]) as Classification[]).map((classification) => {
              const classificationData = groupedClassifications[classificationGroup][classification];

              return (
                <div key={classification} className="cursor-pointer px-4 py-2 hover:bg-base-200 rounded-lg" onClick={() => handleClassificationSelect(classification)}>
                  <div className="size-3 rounded-xs inline-block mr-2" style={{ backgroundColor: classificationData?.color }} />
                  <p className="text-sm inline-block font-semibold">{classificationData?.displayName}</p>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
};
